export interface MessageApi {
  success: (content: string, duration?: number) => void;
  error: (content: string, duration?: number) => void;
  warning: (content: string, duration?: number) => void;
  info: (content: string, duration?: number) => void;
}

class MessageService implements MessageApi {
  private static instance: MessageService | null = null;
  private messageInstance: MessageApi | null = null;

  // singleton pattern
  // get instance
  public static getInstance(): MessageService {
    if (!MessageService.instance) {
      MessageService.instance = new MessageService();
    }
    return MessageService.instance;
  }

  // set message instance
  public setMessageInstance(instance: MessageApi): void {
    this.messageInstance = instance;
  }

  // check if instance is set
  private checkInstance(): boolean {
    if (!this.messageInstance) {
      console.warn(
        'MessageService: message instance is not set, please ensure it is set before using',
      );
      return false;
    }
    return true;
  }

  // implement message API
  public success(content: string, duration?: number): void {
    if (this.checkInstance()) {
      this.messageInstance!.success(content, duration);
    }
  }

  public error(content: string, duration?: number): void {
    if (this.checkInstance()) {
      this.messageInstance!.error(content, duration);
    }
  }

  public warning(content: string, duration?: number): void {
    if (this.checkInstance()) {
      this.messageInstance!.warning(content, duration);
    }
  }

  public info(content: string, duration?: number): void {
    if (this.checkInstance()) {
      this.messageInstance!.info(content, duration);
    }
  }
}

// export singleton instance
export const messageService = MessageService.getInstance();
